import { createContext, useContext } from 'react';

export interface FilterRenderingContext {
  location?: 'panel' | 'toolbar' | 'modal';
}

const context = createContext<FilterRenderingContext>({});

export const filterRenderingContext = context;
export const FilterRenderingContextProvider = context.Provider;
export const FilterRenderingContextConsumer = context.Consumer;

export const useFilterRenderingContext = () => useContext(context);
